<template>
  <div :class="active ? '' : 'hidden '" class="flex flex-col items-center">
    <div class="text-qwray Text">
      {{ $t('payment_methods.in_app.description') }}
    </div>
    <div class="CardParent">
      <div class="flex flex-row mt-4">
        <div class="P-Icon">
          <img src="~@/assets/qwello-app-ic-bigger.svg" />
        </div>
        <div class="flex flex-col justify-center ml-4">
          <div class="Text font-bold">
            {{ $t('payment_methods.in_app.header1') }}
          </div>
          <div class="Text mt-1">
            {{ $t('payment_methods.in_app.text1') }}
          </div>
        </div>
      </div>
      <div class="flex flex-row mt-4" v-show="shouldDisplayCard">
        <div class="P-Icon"><img src="~@/assets/qwello-card-ic.svg" /></div>
        <div class="flex flex-col justify-center ml-4">
          <div class="Text font-bold">
            {{ $t('payment_methods.in_app.header2') }}
          </div>
          <div class="Text mt-1">
            {{ $t('payment_methods.in_app.text2') }}
          </div>
        </div>
      </div>
      <div class="flex flex-row mt-4 hidden">
        <div class="P-Icon"><img src="~@/assets/qwello-tag-ic.svg" /></div>
        <div class="flex flex-col justify-center ml-4">
          <div class="Text font-bold">
            {{ $t('payment_methods.in_app.header3') }}
          </div>
          <div class="Text mt-1">
            {{ $t('payment_methods.in_app.text3') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import matchEntities from '../../../shared/entityHelpers';

export default {
  computed: {
    shouldDisplayCard() {
      return matchEntities(['GERMANY', 'POLAND', 'NETHERLANDS']);
    },
  },
  props: ['active'],
};
</script>
<style scoped>
.Text {
  font-size: 14px;
  color: #2b4047;
}
.P-Icon {
  width: 80px;
  flex: 0 0 auto;
}
.CardParent {
  display: flex;
  flex-direction: column;
}
@media (min-width: 768px) {
  .Text {
    font-size: 16px;
  }
  .CardParent {
    width: 100%;
  }
}
@media (min-width: 830px) {
  .CardParent {
    width: 85%;
  }
}
@media (min-width: 980px) {
  .CardParent {
    width: 80%;
  }
}
@media (min-width: 1024px) {
  .CardParent {
    width: 100%;
  }
}
@media (min-width: 1400px) {
  .Text {
    font-size: 18px;
  }
  .P-Icon {
    width: auto;
  }
}

@media (min-width: 1600px) {
  .Text {
    font-size: 20px;
  }
}
</style>
